import React from 'react';

import { FeedScreen } from '~/components/domain/posts/FeedScreen';

export default function NetworkFeed() {
  return <FeedScreen feedType="network" />;
}
